import React from 'react';
import { Box } from '@mantine/core';

import styles from './Container.module.css';

interface MapbookListType {
  aboveSummaryContent?: React.ReactNode;
  summaryContent?: React.ReactNode;
  belowSummaryContent?: React.ReactNode;
  aboveMapbookContent?: React.ReactNode;
  mapbookContent?: React.ReactNode;
  label: string;
}

const MapbookList = ({
  aboveSummaryContent,
  summaryContent,
  belowSummaryContent,
  aboveMapbookContent,
  mapbookContent,
  label,
}: MapbookListType) => {
  return (
    <Box className={styles.MapbookWrapper}>
      {aboveSummaryContent}
      {summaryContent}
      {belowSummaryContent}
      <Box className={styles.MapbookBar}>{label}</Box>
      {aboveMapbookContent}
      {mapbookContent}
    </Box>
  );
};

export default MapbookList;
